import { client } from '@repo/shared-kit/utils';

import { apiBaseURL } from 'register-partners-js/constants/hosts';

client.init({
  baseURL: apiBaseURL,
});
